import { Extension } from '@tiptap/core'
import { ySyncPluginKey } from '@tiptap/y-tiptap'
import { Plugin, PluginKey } from '@tiptap/pm/state'

/**
 * Een slot op de tekst van een vlak dat alleen te lezen is maar wel te selecteren (besluit 8, keuze 2
 * van 1 november 2026, R-140).
 *
 * Een meelezer die een opmerking plaatst, selecteert tekst. Met het toetsenbord kan dat alleen in een
 * vlak met een cursor, dus is het vlak voor ProseMirror bewerkbaar (`Richtext.tsx`, `selectable`).
 * Dit slot houdt de tekst dan toch dicht: elke transactie die het document verandert wordt geweigerd,
 * behalve die van de samenwerklaag (de tekst van de schrijvers, en de stand uit de geschiedenis), en
 * typen, plakken en slepen komen niet eens tot een transactie. Zo verandert het document in deze
 * browser nooit, en loopt het niet uiteen met dat van de pod; de pod neemt van deze verbinding ook
 * niets aan.
 */
export interface ReadOnlyGuardOptions {
  /** Of het slot nu dicht is; een functie, want het veld kan van rol wisselen. */
  readonly actief: () => boolean
}

export const ReadOnlyGuard = Extension.create<ReadOnlyGuardOptions>({
  name: 'alleenLezenSlot',

  addOptions() {
    return { actief: () => false }
  },

  addProseMirrorPlugins() {
    const active = this.options.actief
    return [
      new Plugin({
        key: new PluginKey('alleenLezenSlot'),
        filterTransaction: (transaction) =>
          !active() || !transaction.docChanged || transaction.getMeta(ySyncPluginKey) !== undefined,
        props: {
          handleDOMEvents: {
            beforeinput: (_view, event) => {
              if (!active()) return false
              event.preventDefault()
              return true
            },
          },
          handlePaste: () => active(),
          handleDrop: () => active(),
          handleTextInput: () => active(),
        },
      }),
    ]
  },
})
